import React from "react";
import { PropTypes } from "prop-types";

import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@material-ui/icons";

const OHSalesOrgChartButton = ({
  children,
  directSubordinates,
  salesChartData,
}) => {
  const style = {
    color: "#fff",
    borderRadius: "10px",
    padding: "1px 2px 1px 1px",
    fontSize: "8px",
    margin: "auto",
    backgroundColor: "white",
    border: "1.5px solid #203a75",
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    justifyContent: "center",
  };

  const number = {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    paddingLeft: "0.25rem",
    color: "rgb(203 34 123)",
    justifyContent: "center",
    alignItems: "center",
  };

  const arrow = {
    width: "0.5rem",
    height: "0.5rem",
    fontSize: "1.125rem",
    lineHeight: "1rem",
    color: "rgb(32 58 117)",
    paddingRight: "-0.50rem",
  };

  const buttonDiv = {
    display: "flex",
    width: "100%",
    height: "85%",
    justifyContent: "center",
    alignItems: "center",
  };

  const chiefButtonDiv = {
    display: "flex",
    width: "100%",
    height: "85%",
    justifyContent: "center",
    alignItems: "center",
  };

  const nsasplcdsButtonDiv = {
    display: "flex",
    width: "100%",
    height: "85%",
    justifyContent: "center",
    alignItems: "center",
    // marginLeft: "8px",
  };

  let divStyle;

  if (salesChartData?.id === 1283) {
    divStyle = chiefButtonDiv;
  } else if ([1, 2, 3].includes(salesChartData?.id)) {
    divStyle = nsasplcdsButtonDiv;
  } else {
    divStyle = buttonDiv;
  }

  return (
    <div style={divStyle}>
      <div className="flex items-center place-content-center" style={style}>
        {/* <UsersIcon className="w-5 h-5 text-secondary" style={userIcon} /> */}
        <span className="font-bold text-secondary" style={number}>
          {directSubordinates}
        </span>
        {children ? (
          <ArrowBackIosRounded className="text-primary w-3 h-3" style={arrow} />
        ) : (
          <ArrowForwardIosRounded
            className="text-primary w-3 h-3"
            style={arrow}
          />
        )}
      </div>
    </div>
  );
};

OHSalesOrgChartButton.propTypes = {
  directSubordinates: PropTypes.number,
  children: PropTypes.array,
};

export default OHSalesOrgChartButton;
